// Classes should implement the following functions :
// preload
// beforePreloaderFadeIn
// afterPreloaderFadeIn
// beforePreloaderFadeOut
// afterPreloaderFadeOut

function Preloader(app, $el, beforeFadeInFunc, afterFadeInFunc) {
  this.app = app;
  this.$el = $el;

  // The click request is to enable audio playback
  this.requireClick = true;
  this.hasGrabbedClick = false;

  this.beforeFadeInFunc = beforeFadeInFunc;
  this.afterFadeInFunc = afterFadeInFunc;
}

Preloader.prototype.init = function (target) {

  if (typeof this.beforeFadeInFunc === "function") {
    this.beforeFadeInFunc();
  }

  // Show loading rect, hide click grab element
  TweenMax.set(this.$el.find(".loader-label .loading"), {autoAlpha: 1});
  TweenMax.set(this.$el.find(".loader-label .request-click"), {autoAlpha: 0});

  if (!this.$el.hasClass("shown")) {
    $("#preloader").fadeIn("normal", $.proxy(function () {
      if (typeof this.afterFadeInFunc === "function") {
        this.afterFadeInFunc();
      }

      this.$el.addClass("shown");

      this.preload(target);
    }, this));
  } else {
    if (typeof this.afterFadeInFunc === "function") {
      this.afterFadeInFunc();
    }

    this.preload(target);
  }
}

Preloader.prototype.update = function (progress) {
  this.$el.find(".fill").css({width: (progress * 100) + "%"})
}

Preloader.prototype.preload = function (target) {

  // Reset fill percent
  this.$el.find(".fill").css({width: "0%"});

  // Promise
  new Promise($.proxy(target["preload"], target))
    .then(function () {
      return new Promise(resolve => setTimeout(resolve, 500))
    })
    .then($.proxy(this.requestClick, this))
    .then($.proxy(function (success, reject) {

      target["beforePreloaderFadeOut"].call(target);

      this.$el.fadeOut("normal", $.proxy(function () {
        this.$el.removeClass("shown");
        this.$el.find(".fill").css({width: "0%"});
        target["afterPreloaderFadeOut"].call(target);
      }, this));

      // console.log(success);

    }, this))
    .catch($.proxy(function (error) {
      console.log(error.message);
      // reject(error.message);
    }, this));
}


Preloader.prototype.requestClick = function () {

  if (this.requireClick == false || this.hasGrabbedClick) {
    return new Promise($.proxy(function (resolve, reject) {
      resolve();
    }, this));
  }

  var tl = new TimelineMax();
  tl.to(this.$el.find(".loader-label .loading"), 0.5, {
    autoAlpha: 0
  });
  tl.to(this.$el.find(".loader-label .request-click"), 0.5, {
    autoAlpha: 1
  }, "-=0.3");

  return new Promise($.proxy(function (resolve, reject) {
    $("body").css("cursor", "pointer");
    $(document).one("click", $.proxy(function () {
      this.hasGrabbedClick = true;
      TweenMax.to(this.$el.find(".loader-label .request-click"), 0.3, {autoAlpha: 0});
      $("body").css("cursor", "auto");
      resolve()
    }, this));
  }, this));
}


// Expose Preloader
window.Preloader = Preloader;
